import React, { memo, useState, useEffect } from 'react';
import classnames from 'classnames';
import Loading from '@gp/components/Loading';
import { isVideoWithSuffix } from '@gp/utils/common';
import './index.scss';
interface IGeneralIFrameProps extends IBaseProps {
  src: string;
  isLoading?: boolean;
}

const GeneralIFrame: React.FC<IGeneralIFrameProps> = (props) => {
  const { src, isLoading: isLoadingOuter = false, style, className, docSuffix } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isVideoLoading, setIsVideoLoading] = useState<boolean>(true);

  const handleIFrameLoaded = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
  }, [src]);

  const video = document.getElementById('videoId');
  // 当视频可以播放而不需要暂停缓冲时触发
  video?.addEventListener('canplay', () => {
    setIsVideoLoading(false);
  });

  return (
    <div style={style} className={classnames('gp-common-iframe-comp', className)}>
      {docSuffix && isVideoWithSuffix(docSuffix) ? (
        <>
          {isVideoLoading && <Loading style={{ position: 'unset' }} loading loadingBg="#f2f3f5" />}
          <div className="dbg-general-frame-video-div">
            <video
              id="videoId"
              controls
              //  autoPlay
              //  muted
              playsInline
              className="dbg-general-frame-video"
            >
              <source src={src} type="video/mp4" />
            </video>
          </div>
        </>
      ) : (
        <>
          {(isLoadingOuter || isLoading) && <Loading style={{ position: 'unset' }} loading loadingBg="#f2f3f5" />}
          <iframe className="gp-common-iframe" src={src} onLoad={handleIFrameLoaded}></iframe>
        </>
      )}
    </div>
  );
};

export default memo(GeneralIFrame);
